/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mBtnMpay.vue?vue&type=template&id=38e99a0d&scoped=true"
import script from "./mBtnMpay.vue?vue&type=script&lang=js"
export * from "./mBtnMpay.vue?vue&type=script&lang=js"
import style0 from "./mBtnMpay.vue?vue&type=style&index=0&id=38e99a0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e99a0d",
  null
  
)

export default component.exports